import React, { FC, useEffect } from 'react';
import { Switch, Redirect, RouteComponentProps } from 'react-router-dom';
import PruRoute from '../../../../../common/components/PruRoute';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import {
  SALESKIT_BASE_PATH,
  RECRUIT_LIBRARY_BASE_PATH,
  SALES_MATERIAL_BASE_PATH,
  SALES_LIBRARY_BASE_PATH,
} from '../../../constants';
import SalesLibraryListPage from './SalesLibraryListPage';
import SalesLibraryCreatePage from './SalesLibraryPageCreatePage';
import PerformancePage from './PerformancePage';
import { ModulePermissionProps } from '../../../../../common/module/types';
import { useDispatch } from 'react-redux';
import { resetState } from '../../../redux/saleskit.slice';

const SalesLibraryRoutes: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      // clear list state
      dispatch(resetState());
    };
  }, []);
  return (
    <Switch>
      <Redirect
        exact
        from={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${SALES_LIBRARY_BASE_PATH}`}
        to={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${SALES_LIBRARY_BASE_PATH}/list`}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${SALES_LIBRARY_BASE_PATH}/list`}
        render={(props) => (
          <SalesLibraryListPage
            {...props}
            enableRead={enableRead}
            enableCreate={enableCreate}
            enableUpdate={enableUpdate}
          />
        )}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/create`}
        component={SalesLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/edit/:id`}
        component={SalesLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/view/:id`}
        component={SalesLibraryCreatePage}
      />
      <PruRoute
        exact
        path={`${SALESKIT_BASE_PATH}${SALES_MATERIAL_BASE_PATH}${RECRUIT_LIBRARY_BASE_PATH}/performance/:id`}
        component={PerformancePage}
      />
      <Redirect to={NOT_FOUND_ERROR_PAGE_PATH} />
    </Switch>
  );
};

export default SalesLibraryRoutes;
